import React from "react";

interface LogoPhiStaticProps {
  className?: string;
}

export default function LogoPhiStatic({ className = "w-16 h-16" }: LogoPhiStaticProps) {
  return (
    <svg
      viewBox="0 0 100 100"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter id="glow-phi-static">
          <feGaussianBlur stdDeviation="2" result="coloredBlur" />
          <feMerge>
            <feMergeNode in="coloredBlur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <line
        x1="50"
        y1="20"
        x2="50"
        y2="80"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <circle
        cx="50"
        cy="50"
        r="20"
        stroke="white"
        strokeWidth="4"
        fill="none"
      />

      <path
        d="M 10 50 L 25 50 L 32 35 L 40 65 L 48 40 L 56 55 L 68 50 L 90 50"
        stroke="#FF6B00"
        strokeWidth="2.5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        filter="url(#glow-phi-static)"
      />
    </svg>
  );
}
